import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { AppLoader } from '~/components/loader'
import { useCurrentOrganization } from '~/hooks'

export const Route = createFileRoute('/_authenticated/org_/$orgId/$')({
  component: RouteComponent,
})

function RouteComponent() {
  const org = useCurrentOrganization()
  const navigate = useNavigate()
  const { _splat } = Route.useParams()

  useEffect(() => {
    if (org) {
      navigate({
        to: `/${org.alias}/${_splat || ''}`,
        search: (prevSearch) => prevSearch,
        replace: true,
      })
    }
  }, [org, _splat, navigate])

  return <AppLoader />
}
